import { IUserShort } from '../../../entities';

export interface IClassicPlayerConfig extends IUserShort {
  color: string;
  itemsNumber: number;
  totalChance: number;
  totalPrice: number;
}
